import { render, staticRenderFns } from "./PanelSeparator.global.vue?vue&type=template&id=fc785eba&scoped=true&lang=pug&"
import script from "./PanelSeparator.global.vue?vue&type=script&lang=ts&"
export * from "./PanelSeparator.global.vue?vue&type=script&lang=ts&"
import style0 from "./PanelSeparator.global.vue?vue&type=style&index=0&id=fc785eba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc785eba",
  null
  
)

export default component.exports